import PreserveExample from "../../../../content/posts/preserve-new-lines-and-spacing/PreserveExample";
import * as React from 'react';
export default {
  PreserveExample,
  React
};